import VideoPlayer from 'components/shared/video/video';
import styles from './media.module.scss';
import Image from '../../shared/image';

const MeidaSection = ({ data }) => {
  const { media, anchorId } = data;

  return (
    <section id={anchorId}>
      {media.type === 'Image' && (
        <Image
          className={styles.media}
          src={media.image}
          loading="lazy"
          layout="responsive"
          sizes="(max-width: 899px) 100vw, 50vw"
        />
      )}
      {media.type === 'Video' && media.video && (
        <VideoPlayer
          className={styles.media}
          thumbnail={media.thumbnail}
          source={media.video}
          controlsVersion={1}
          focalPoint={media.focalPoint}
          aspectRatio={media.videoAspectRatio}
          objectFit={media.objectFit}
        />
      )}
    </section>
  );
};

export default MeidaSection;
